'use client';

import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypeSubscriptionRecord } from '../types';

type SubscriptionsParams = {
  userUuid: string;
};

export default function useSubscriptions(params: SubscriptionsParams) {
  const { userUuid } = params;

  const shouldFetch = userUuid;

  const subscriptionsUri = `${
    API_URLS.SUBSCRIPTION_MANAGER_PROXY
  }/recipient/${userUuid}/subscriptions`;

  const {
    data: subscriptionsData,
    isLoading: isLoadingSubscriptions,
    error: subscriptionsError,
    mutate: mutateSubscriptions,
  } = useSWR<TypeSubscriptionRecord[], Error>(
    shouldFetch ? subscriptionsUri : null,
    SWR_REQUEST_DEFAULTS,
  );

  return {
    data: subscriptionsData,
    loading: isLoadingSubscriptions,
    error: subscriptionsError,
    mutate: mutateSubscriptions,
  };
}
